import React from 'react'

export default  class  Gradient extends  React.Component {
    render(){

        return (
        <div className="row">
            <div className="col-xs-12 noPadding gradientContainer">
                <span>0</span>
                <img className="image-responsive" id="gradient" alt="Color Gradient" src="images/gradient.png"/>
                <span>100</span>

            </div>
        </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Map/BettAppBar/Gradient.js